module.exports = __webpack_public_path__ + "imgs/cbd-stores.20512260ef21b52bd30ebe88514fcf83.svg";